import apiClient from './apiClient';

const API_URL = '/tramites/pension';

// Listar / filtrar trámites de Pensión
export const getTramitesPension = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite (incluye checklist)
export const getTramitePensionById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite de Pensión
export const crearTramitePension = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de Pensión:', error.response?.data || error.message);
        throw error;
    }
};

// Preview del checklist: depende del tipo de pensión, el vínculo del beneficiario, si hay hijos
// reconocidos por ambos (solo afecta CONVIVIENTE, pero se manda siempre por simplicidad), si el
// domicilio del causante coincide con el del beneficiario (solo afecta CONYUGE; null = sin evaluar,
// no se manda para no forzar "coincide") y las fechas de defunción del causante / certificación y
// vencimiento del CUD (solo afectan HIJO_CON_DISCAPACIDAD: importa si el CUD estaba vigente EL DÍA
// del fallecimiento, no hoy — ver TramitePensionService.esCudNoVigenteAlFallecimiento).
export const getChecklistFormularios = async (tipoPension, vinculo, hijosReconocidosAmbos = false, domicilioCausanteCoincide = null, causanteFechaDefuncion = null, fechaCertificacionCud = null, fechaVencimientoCud = null) => {
    const params = {};
    if (tipoPension) params.tipoPension = tipoPension;
    if (vinculo) params.vinculo = vinculo;
    params.hijosReconocidosAmbos = !!hijosReconocidosAmbos;
    if (domicilioCausanteCoincide !== null && domicilioCausanteCoincide !== undefined) {
        params.domicilioCausanteCoincide = domicilioCausanteCoincide;
    }
    if (causanteFechaDefuncion) params.causanteFechaDefuncion = causanteFechaDefuncion;
    if (fechaCertificacionCud) params.fechaCertificacionCud = fechaCertificacionCud;
    if (fechaVencimientoCud) params.fechaVencimientoCud = fechaVencimientoCud;
    const response = await apiClient.get(`${API_URL}/formularios`, { params });
    return response.data;
};

// Editar datos del trámite (no el cliente)
export const actualizarTramitePension = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable con firma)
export const actualizarComentariosPension = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Registrar/editar la moratoria del causante (acción puntual desde la alerta de regularidad
// fallida en la ficha; separada del PUT general para no perder el valor en cada "Editar datos")
export const actualizarMoratoriaPension = async (id, moratoriaCausante) => {
    const response = await apiClient.patch(`${API_URL}/${id}/moratoria`, { moratoriaCausante });
    return response.data;
};

// Actualizar un ítem del checklist (marcar presentado / adjuntar archivo)
export const actualizarChecklistItem = async (idItem, { presentado, idArchivo }) => {
    const response = await apiClient.patch(`${API_URL}/formularios/${idItem}`, { presentado, idArchivo });
    return response.data;
};

// Iniciar el reclamo administrativo de nulidad sobre la denegatoria (solo trámites Cerrado
// desfavorable): reabre el trámite en "Nulidad Iniciada" y reinicia el checklist sin presentar.
export const iniciarNulidadPension = async (id, { fechaDenegatoria, motivoDenegatoria }) => {
    const response = await apiClient.patch(`${API_URL}/${id}/nulidad`, { fechaDenegatoria, motivoDenegatoria });
    return response.data;
};

const pensionService = {
    getTramitesPension,
    getTramitePensionById,
    crearTramitePension,
    getChecklistFormularios,
    actualizarChecklistItem,
    actualizarTramitePension,
    actualizarComentariosPension,
    actualizarMoratoriaPension,
    iniciarNulidadPension,
};

export default pensionService;
